import api from '@/api'
import WhitelistRequest from '@/model/whitelist/WhitelistRequest'
import WhitelistSearchRequest from '@/model/whitelist/WhitelistSearchRequest'
import AffiliateRequest from '@/model/affiliate/AffiliateRequest';

export default {
  namespaced: true,
  state: {
    statusIds: []
  },
  getters: {
    statusIds: state => state.statusIds,
    statusById: state => id => state.statusIds.find(status => status.id === id)
  },
  mutations: {
    updateData(state, data) {
    }
  },
  actions: {
    refreshData({ commit }) {
      return api.base()
        .get('/whitelist/data')
        .then(
          response => {
            commit('updateData', response.data.data);
          }
        );
    },
    getAllWhitelists(actions, {filter,pagination,sort}) {
      return api.base()
        .post('/whitelist/get/all',
          WhitelistSearchRequest( { ...(filter || {}), pagination, sort, })
        )
        .then(response => ({
            data: response.data.data,
            pagination: { page: response.data.metadata.page, total: response.data.metadata.total},
            sort: response.data.metadata.sort
          })
        )
    },
    getWhitelistById({ commit }, id) {
      return api.base()
        .get('/whitelist/id/' + id)
        .then(
          response => {
            return response.data.data
          }
        )
    },

    createWhitelist({ commit }, { whitelist }) {
      return api.base()
        .post('/whitelist/add', WhitelistRequest(whitelist))
        .then(
          response => {
            return response.data.data;
          }
        );
    },
    updateWhitelist({ commit }, { whitelist, id }) {
      return api.base()
        .post('/whitelist/update/'+id, WhitelistRequest(whitelist))
        .then(
          response => {
            return response.data.data
          }
        )
    }
  },
}
